import { combineActions, handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';

import * as actions from './actions';

const reducer = handleActions(
  {
    [actions.getShares]: (state) => state.set('isLoading', true),
    [actions.getSharesSuccess]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.getSharesFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [actions.createShare]: (state, { payload: Share }) => resourceUpserters.upsertResource(state, Share),
    [actions.createShareSuccess]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.deleteShare),

    [actions.updateShare]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateShare),
    [actions.updateShareSuccess]: (state, { payload: Share, asyncDispatch }) => {
      asyncDispatch(actions.getShares());
      return resourceUpserters.upsertResource(state, Share);
    },

    [actions.deleteShare]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createShare),
    [actions.deleteShareSuccess]: (state, { payload: Share }) => resourceUpserters.upsertResource(state, Share),

    [combineActions(actions.createShareFailure, actions.updateShareFailure, actions.deleteShareFailure)]: (
      state,
      { payload: error, asyncDispatch },
    ) => {
      asyncDispatch(actions.getShares());
      return resourceUpserters.resetResources(state, error);
    },
  },
  resourceStoreTypes.mkQcsSyncResourceStore({ resourceName: 'SHARES' }),
);

export const REDUCER_KEY = 'shareStore';
export default reducer;
